// extracted by mini-css-extract-plugin
export default {"container":"EmailTab_container__0p8tz","info-box":"EmailTab_info-box__ril0K"};